function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "row1",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7971",
    style: {
      display: "inline",
      fill: "#ac2720",
      fillOpacity: 1,
      stroke: "#ac2720",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 931.34766,752.89258 -279.51758,39.60937 9.36914,43.23438 301.4375,-21.94531 z M 347.02344,835.69336 14.4375,882.82227 342.98438,858.90234 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9437",
    style: {
      fill: "#cd2f26",
      fillOpacity: 1,
      stroke: "#cd2f26",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 962.63672,813.79102 -301.4375,21.94531 8.65234,39.92773 323.10547,-3.52929 z M 342.98438,858.90234 14.4375,882.82227 339.44141,879.27344 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "row2",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1024",
    style: {
      display: "inline",
      fill: "#ac2720",
      fillOpacity: 1,
      stroke: "#ac2720",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 847.875,590.75 625.0332,668.84375 635.61328,717.66211 879.75,652.75 Z M 359.88477,761.76172 14.4375,882.82227 354.55664,792.39062 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4245",
    style: {
      fill: "#cd2f26",
      fillOpacity: 1,
      stroke: "#cd2f26",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 879.75,652.75 -244.13672,64.91211 9.23438,42.61328 263.96093,-51.3125 z M 354.55664,792.39062 14.4375,882.82227 350.17773,817.55664 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "row3",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24961",
    style: {
      display: "inline",
      fill: "#073346",
      fillOpacity: 1,
      stroke: "#093248",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 763.58789,427.24414 14.4375,882.82227 765.45312,501.21094 l 0.0527,-0.41016 -29.42188,-15.50586 32.69532,-6.08594 5.43164,-31.4707 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28410",
    style: {
      display: "inline",
      fill: "#09445d",
      fillOpacity: 1,
      stroke: "#073959",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 765.45312,501.21094 14.4375,882.82227 824.68945,545.85156 813.59766,524.1875 785.0293,510.58789 761.18945,533.77734 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "row4",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9352",
    style: {
      display: "inline",
      fill: "#073346",
      fillOpacity: 1,
      stroke: "#093248",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 679.96289,265.09961 14.4375,882.82227 682.48438,341.3125 l 0.11914,-0.91016 -29.42188,-15.50586 32.69531,-6.08593 5.44532,-31.5586 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11871",
    style: {
      display: "inline",
      fill: "#09445d",
      fillOpacity: 1,
      stroke: "#073959",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 682.48438,341.3125 14.4375,882.82227 741.44531,384.04688 l -10.47656,-20.12891 -28.8418,-13.72852 -23.83984,23.18946 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "row5",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4714",
    style: {
      display: "inline",
      fill: "#073346",
      fillOpacity: 1,
      stroke: "#093248",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 596.76562,103.74805 14.4375,882.82227 598.99609,178.03711 l 0.084,-0.64258 -29.42188,-15.50586 32.69532,-6.08594 5.32031,-30.82226 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4910",
    style: {
      display: "inline",
      fill: "#09445d",
      fillOpacity: 1,
      stroke: "#073959",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 598.99609,178.03711 14.4375,882.82227 657.69922,221.6582 l -10.9336,-21.07226 -28.1621,-13.4043 -23.8379,23.18945 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "row6",
    style: {
      fill: "#09445d",
      fillOpacity: 1,
      stroke: "#093248",
      strokeWidth: 1.00157,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 14.437245,882.82215 C 46.690664,817.16341 46.690664,817.08662 46.690664,817.08662 L 412.85397,61.469248 l 162.08984,-10e-7 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.23634806bac2396e9ea94b9bb41d1363.svg";
export { ForwardRef as ReactComponent };